import TopNavigation from "../Navigation/TopNavigation"
import Loading from "./Loading"
import { useState, useEffect } from 'react';
import { isLogin } from "../Utils/Cookies";
import './StorybookTheme.css';

const MobilePage = ({ children, className, loading, loadingMessage, topCheckDisabled }) => {

  const [isTop, setIsTop] = useState(true)

  const heroNo = isLogin() ? localStorage.getItem("heroNo") : 1
  const heroes = JSON.parse(localStorage.getItem("heroes"))
  const hero = heroes && heroes.filter(hero => hero.heroNo == heroNo)[0]

  const handleScroll = () => {
    if (topCheckDisabled) {
      setIsTop(true)
      return
    }
    if (window.scrollY < 3) {
      setIsTop(true)
    } else {
      setIsTop(false)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])


  return <div className={(className || '') + ' w-full lg:bg-white relative font-sans'}>

    {
      loading && <Loading loadingMessage={loadingMessage} />
    }
    <div className='w-full sm:max-w-md mx-auto bg-background-floor min-h-screen relative'>
      <TopNavigation hero={hero} isTop={isTop} />
      <div>
        {children}
      </div>
    </div>
  </div>
}

export default MobilePage
